import { ACTIVITY_SUMMARY_FILTER_TYPE } from './PerformancePageSelectors';
import { BaseFilterReducer } from './BaseFilterReducer';

export const ActivitySummaryFilterReducer = BaseFilterReducer(
  ACTIVITY_SUMMARY_FILTER_TYPE
);
